import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  TextField
} from '@material-ui/core';

import { addProduct } from 'redux/actions';

const AddProductModal = (props) => {

  const [values, setValues] = useState({
    name: "",
    unitCost: "",
    category: props.productCategories[0] ? props.productCategories[0].name : "",
    company: props.productCompanies[0] ? props.productCompanies[0].name : "",
    barcode: ""
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newProduct = {
      displayId: props.displayId,
      category: values.category,
      company: values.company,
      name: values.name,
      unitCost: values.unitCost,
      barcode: values.barcode
    };
    props.addProduct(newProduct, props.activeUserId);

    props.closeModal(true);
  };

  return (
    <Modal open={props.open}>
      <form
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Card>
          <CardHeader
            subheader="The information can be edited later"
            title="Product"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the Product Name"
                  label="Name"
                  name="name"
                  onChange={handleChange}
                  required
                  value={values.name}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please select the Product's Category"
                  label="Select Category"
                  name="category"
                  onChange={handleChange}
                  required
                  select
                  SelectProps={{ native: true }}
                  value={values.category}
                  variant="outlined"
                >
                  {props.productCategories.map((option) => (
                    <option
                      key={option.name}
                      value={option.name}
                    >
                      {option.name}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please select the Product's Company"
                  label="Select Brand"
                  name="company"
                  onChange={handleChange}
                  required
                  select
                  SelectProps={{ native: true }}
                  value={values.company}
                  variant="outlined"
                >
                  {props.productCompanies.map((option) => (
                    <option
                      key={option.name}
                      value={option.name}
                    >
                      {option.name}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the Unit Cost of the Product"
                  label="Unit Cost"
                  name="unitCost"
                  onChange={(event) => setValues({ ...values, unitCost: parseFloat(event.target.value) || 0 })}
                  required
                  value={values.unitCost}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Enter the Product Barcode or Scan it"
                  label="Barcode"
                  name="barcode"
                  onChange={handleChange}
                  required
                  value={values.barcode}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 2
            }}
          >
            <Button
              color="primary"
              variant="contained"
              type="submit"
            >
              Save Product
            </Button>
            <Button sx={{ mx: 1 }} onClick={props.closeModal.bind(this, true)} >
              Cancel
            </Button>
          </Box>
        </Card>
      </form>
    </Modal>
  )
};

export default connect (null, {addProduct}) (AddProductModal);